<template>
  <div class="become-supplier">
    <span>{{ $t('lbl_emp2_NotASupplierMember') }}</span>
    <a
      :href="url || '#'"
      target="_blank"
      rel="noopener"
      :title="url"
      @click.prevent="handleClick"
      class="supplier-link"
      t_label="btn_emp2_ApplyForMembership"
    >
      {{ $t('lbl_emp2_ApplyForMembership') }} 
      <svg class="arrow-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="arrow_forward">
          <mask id="mask0_2000_29749" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect id="Bounding box" width="18" height="18" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_2000_29749)">
            <path id="arrow_forward_2" d="M12.1303 9.74976H2.99902V8.24976H12.1303L7.93027 4.04976L8.99902 2.99976L14.999 8.99976L8.99902 14.9998L7.93027 13.9498L12.1303 9.74976Z" fill="#7366FF"/>
          </g>
        </g>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  name: 'BecomeSupplierLink',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.become-supplier {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.become-supplier span {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.2px;
}

.supplier-link {
  color: #7366FF;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 18.2px;
  letter-spacing: 0;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.supplier-link .arrow-icon {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>

